import type { Filters } from './Assessment.types';

const getFilterValue = (value: string | string[]) => (Array.isArray(value) ? value.join(',') : value);

const getAlertValue = (alerts: string | string[], value: string) => {
  const values = Array.isArray(alerts) ? alerts : alerts.split(',');
  return values.includes(value) ? 'true' : '';
};

export const getAssessmentTableFilterValues = (filter: Filters) => [
  getFilterValue(filter.flag),
  getFilterValue(filter.examTaskGroupSolutionScoreId),
  getFilterValue(filter.status),
  getFilterValue(filter.pointsFrom),
  getFilterValue(filter.pointsTo),
  getFilterValue(filter.progress),
  getFilterValue(filter.alerts),
  getFilterValue(filter.verificationState),
  getFilterValue(filter.downloadDateFrom),
  getFilterValue(filter.downloadDateTo),
  getFilterValue(filter.updateDateFrom),
  getFilterValue(filter.updateDateTo),
  getFilterValue(filter.assessmentQualityId),
  getFilterValue(filter.examinerName),
  getFilterValue(filter.examTaskNumbersWithNoAnswer),
];

export const getAssessmentAssignmentDeleteFilterValues = (filter: Filters) => [
  getFilterValue(filter.examTaskGroupSolutionScoreId),
  getFilterValue(filter.status),
  getFilterValue(filter.pointsFrom),
  getFilterValue(filter.pointsTo),
  getFilterValue(filter.progress),
  getFilterValue(filter.downloadDateFrom),
  getFilterValue(filter.downloadDateTo),
  getFilterValue(filter.updateDateFrom),
  getFilterValue(filter.updateDateTo),
  getAlertValue(filter.alerts, '4'),
  getAlertValue(filter.alerts, '6'),
  getAlertValue(filter.alerts, '7'),
  getFilterValue(filter.flag),
  getAlertValue(filter.alerts, '1'),
  getAlertValue(filter.alerts, '2'),
  getAlertValue(filter.alerts, '3'),
  getAlertValue(filter.alerts, '9'),
];
